import React from 'react';
import RoleForm from './role_form';
import {notification} from 'antd';
import history from '../../modules/History';
import {addRoleItem} from '../../modules/Api';

class AddRole extends React.Component {
    constructor() {
        super();
        this.state = {
            data: {},
            submitted: false,
        }

    }
    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        addRoleItem(values, (res) => {
            this.setState({submitted:false});

            if(res.status==200){
                notification.open({
                    message: `نقش با موفقیت اضافه شد!`,
                });
                history.item.push(`/acl/roles`);
            }
            else if(res.message != undefined){
                notification.open({
                    message: res.message,
                });
            }
        });
    }
    render() {
        return (<RoleForm initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted}/>);
    }
}

export default AddRole;


// WEBPACK FOOTER //
// ./src/containers/ACL/add_role.js